module.exports = __webpack_public_path__ + "img/disney.857e72d2.svg";